<template>
  <div class="head">
    <div class="layout">
      <h1 class="head-logo" @click="gotoHome">
        <!-- <i class="iconfont iconziyuan21"></i> -->
        <!-- <svg class="p-icon" aria-hidden="true">
          <use href="#iconziyuan21"></use>
        </svg> -->
        <img src="../assets/logo.png" class="image-area"/>湖南德礼来科技有限责任公司
      </h1>
      <div class="nav clearfix" >
        <div
          class="nav-item"
          v-for="(item, index) in list"
          :key="index"
          :class="current == index ? 'active' : ''"
          @click="gotoPath(index)"
          @mouseenter="visible(index)"
          @mouseleave="invisible(index)"
        >
          <span class="nav-item-hd">
            {{ item.label }}
            <img
              class="icons"
              v-if="item.derc"
              src="../assets/home_nav_pop.png"
            />
          </span>

          <div class="nav-item-bd" v-if="item.showScd">
            <div
              class="bd-item"
              v-for="(scdItem, scdIndex) in list[index].child"
              :key="scdIndex + 'scd'"
              @click="gotoPosition(scdIndex, 1)"
            >
              {{ scdItem.label }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      list: [
        {
          index: 0,
          label: "首页",
          showScd: false
        },
        {
          index: 1,
          label: "关于我们",
          showScd: false
        },
        // {
        //   index: 1,
        //   label: "产品介绍",
        //   showScd: false,
        //   derc: true,
        //   child: [
        //     {
        //       label: "视频中心",
        //       value: "0"
        //     },
        //     {
        //       label: "金融商业生态平台",
        //       value: "1"
        //     },
        //     {
        //       label: "移动金融服务平台",
        //       value: "2"
        //     },
        //     {
        //       label: "AI人工智能平台",
        //       value: "3"
        //     }
        //   ]
        // },
        // {
        //   index: 2,
        //   label: "解决方案",
        //   showScd: false
        // },
        // {
        //   index: 3,
        //   label: "关于我们",
        //   showScd: false
        // },
        // {
        //   index: 4,
        //   label: "加入我们",
        //   showScd: false
        // }
      ]
    };
  },
  props: {
    //当前索引
    current: {
      type: Number,
      default: 0
    }
  },
  methods: {
    gotoHome() {
      this.$router.push("/home");
    },
    gotoPath(tag) {
      this.$store.commit("setProductIndex", { index: -3 });
      switch (tag) {
        case 0:
          this.$router.push("/home");
          break;
        case 1:
          this.$router.push("/about");
          break;
        
        default:
          this.$router.push("/home");
      }
    },
    visible(index) {
      this.list[index].showScd = true;
    },
    invisible(index) {
      this.list[index].showScd = false;
    },
    gotoPosition(index) {
      this.$store.commit("setProductIndex", { index: index }); //更新点击的产品索引值

      this.$router.push({
        name: "product",
        params: {
          current: index,
          type: 1
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
@color: #f9ff00;

.head {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 80px;
  min-width: 1140px;
  background-color: #222;
  .layout {
    height: 100%;
  }

}
.head-logo {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 226px;
  height: 38px;
  color: #fff;
  white-space: nowrap;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-size:20px;
  .p-icon {
    width: 226px;
    height: 38px;
  }
  // text-indent: -9999em;
  // overflow: hidden;
  // background: url("../assets/logo.png") no-repeat;
  // background-size: 100%;
}
.nav {
  margin-left: 350px;
  .nav-item {
    position: relative;
    float: left;
    padding: 31px 10px;
    margin: 0 40px;
    color: #fff;
    line-height: 1;
    font-size: 18px;
    cursor: pointer;
    &.active {
      .nav-item-hd {
        color: @color;
      }

      &:after {
        content: "";
        position: absolute;
        left: 5px;
        right: 5px;
        bottom: 18px;
        height: 3px;
        background-color: @color;
      }
    }
  }
}
.nav-item-hd {
  display: block;
  position: relative;
  .icons {
    position: absolute;
    right: -25px;
    top: 50%;
    margin-top: -4px;
    width: 16px;
    height: 16px;
    transform: rotate(180deg);
    transition: all 0.5s;
  }
  &:hover {
    .icons {
      margin-top: -8px;
      transform: rotate(360deg);
      transition: all 0.3s;
    }
  }
}
.nav-item-bd {
  position: absolute;
  left: -18px;
  top: 80px;
  z-index: 99;
  font-size: 16px;
  line-height: 2.875;
  white-space: nowrap;
  background-color: rgba(33, 33, 33, 0.7);
  .bd-item {
    padding: 0 18px;
    &:hover {
      color: @color;
    }
    &:nth-child(1) {
      padding-top: 10px;
    }
    &:nth-last-child(1) {
      padding-bottom: 10px;
    }
  }
}
.image-area{
  height: 50px;
  width: 50px;
  margin-right: 15px;
}
</style>
